import { render, staticRenderFns } from "./CrossPromotionIcon.vue?vue&type=template&id=6f21942c&"
import script from "./CrossPromotionIcon.vue?vue&type=script&lang=js&"
export * from "./CrossPromotionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports